import { Col, Grid, Modal, Popover, Row } from "antd";
import { ColumnsType } from "antd/es/table";
import toast from "react-hot-toast";
import { GetFileByEntityId } from "../../../services/MediumService";
import { GetPositionById } from "../../../services/PositionService";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { useEffect, useState } from "react";
import { GetViews } from "../../../services/NoticeService";
import { useSelector } from "react-redux";
import { getMyPosition } from "../../../features/position/positionSlice";
import noImage from "../../../assets/vectors/no-image.svg";
import loading from "../../../assets/loading.gif";
import CompanyIcon from "../../icons/NoticeCard/CompanyIcon";
import { ColorPalette } from "../../share/color/colorPalette";
import TedShareIcon from "../../icons/TedShareIcon";
import TedSaveIcon from "../../icons/TedSaveIcon";
import EyeIconGray from "../../icons/NoticeCard/EyeIconGray";
import ClockIcon from "../../icons/NoticeCard/ClockIcon";
import CustomLabel from "../../share/customLabel";
import CustomButton from "../../share/customButton";

const NoticeCardV3 = (noticeInput: any) => {
  const params = useParams();
  const [notice, setNotice] = useState<any>(null);
  const [company, setCompany] = useState("");
  const [image, setImage] = useState<any>(null);
  const myPositions = useSelector(getMyPosition);
  const [getViewsModal, setViewsModal] = useState(false);
  const [getModalNoticeId, setModalNoticeId] = useState(null);
  const [getViewsData, setViewsData] = useState([]);
  const [getIsAccelerated, setIsAccelerated] = useState(false);
  const { useBreakpoint } = Grid;
  const [searchParams] = useSearchParams();

  const location = useLocation();
  useEffect(() => {
    setNotice(noticeInput.notice);
    setIsAccelerated(noticeInput.acc.includes(noticeInput.notice.id));
  }, []);

  useEffect(() => {
    setNotice(noticeInput.notice);
  }, [noticeInput]);

  useEffect(() => {
    if (notice) {
      GetPositionByIdAsync();
      GetImage();
    }
  }, [notice]);

  useEffect(() => {
    if (getModalNoticeId !== undefined && getModalNoticeId !== null) {
      GetViews(getModalNoticeId).then((p) => {
        console.log("datadata", p.data.data);
        setViewsData(p.data.data);
      });
    }
  }, [getModalNoticeId]);

  const navigate = useNavigate();
  const GetPositionByIdAsync = async () => {
    if (notice) {
      await GetPositionById(notice.ResponsiblePositionId).then((p) => {
        if (p?.data?.company?.name) {
          setCompany(p.data.company.name);
        }
      });
    }
  };

  const GetImage = async () => {
    if (notice) {
      setImage(noImage);
      return;
      await GetFileByEntityId(notice.id).then((p) => {
        //console.log("ima", p.data);

        if (p.data) {
          setImage(p.data);
        } else {
          setImage(noImage);
        }
      });
    }
  };

  const handleRemoveFlag = () => {
    const newParams = new URLSearchParams(searchParams);
    newParams.delete("flag");
    setEditingDecision(false);
    navigate(`/Dashboard/NoticeOffers?id=${notice.Id}&&${newParams}`, {
      replace: true,
    });
  };

  // const response = await GetFileByEntityId(data.id);

  const handleCopyContent = (input: string) => {
    const contentToCopy = input; // Replace with the content you want to copy

    const textarea = document.createElement("textarea");
    textarea.value = contentToCopy;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);

    console.log("Content copied to clipboard");
  };
  const copyNotice = (input: any) => {
    console.log(input);

    handleCopyContent(input);
    toast.success("کپی شد");
  };

  const columns: ColumnsType<any> = [
    {
      title: "بازدید کنندگان",
      dataIndex: "companyId",
      key: "companyId",
      render: (item, record, index) => <>{item}</>,
    },
  ];
  const [getEditingDecision, setEditingDecision] = useState(false);
  return (
    <>
      {notice ? (
        <>
          <Row
            style={{
              fontFamily: "YekanBakhVF",
              textAlign: "center",
              width: "420px",
              height: "182px",
              marginTop: "16px",
              backgroundColor: "transparent",
              //zIndex: -99,
            }}
          >
            <Col
              onClick={() =>
                navigate(
                  `/Dashboard/NoticeOffers/${notice.Id}?${searchParams}`,
                  {
                    replace: true,
                  }
                )
              }
              style={{
                borderRadius: "12px",
                border: "1px solid #DDE1E6",
                width: "100%",
                backgroundColor:
                  params.id === notice.Id ? "#abd5ff33" : "transparent",

                cursor: "pointer",
              }}
            >
              <Row
                style={{
                  textAlign: "center",
                  marginTop: "16px",
                  backgroundColor: "transparent",
                }}
              >
                <Col
                  style={{
                    width: "95%",
                    height: "150px",
                    backgroundColor: "transparent",
                    margin: "auto",
                  }}
                >
                  <Row>
                    <Col style={{ width: "150px" }}>
                      {" "}
                      <div
                        style={{
                          textAlign: "center",

                          margin: "auto",
                          //backgroundColor:"red",
                          verticalAlign: "middle",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          paddingLeft: "8px",
                        }}
                      >
                        {image !== null ? (
                          <>
                            <img
                              src={image}
                              alt={notice.Title}
                              width={150}
                              height={150}
                              style={{
                                borderRadius: "8px",
                              }}
                            />
                          </>
                        ) : (
                          <>
                            <img
                              src={loading}
                              alt={notice.Title}
                              width={150}
                              height={150}
                              style={{
                                borderRadius: "8px",
                              }}
                            />
                          </>
                        )}
                      </div>
                    </Col>
                    <Col style={{ width: "220px", overflow: "hidden" }}>
                      <Row style={{ height: "18px", textAlign: "right" }}>
                        <Col>
                          <CompanyIcon />
                        </Col>
                        <Col
                          style={{
                            marginRight: "4px",
                            paddingTop: "2px",

                            overflow: "hidden",
                            color: ColorPalette.primaryBlue[500],
                            fontFamily: "YekanBakhVF",
                            fontSize: "13px",
                          }}
                        >
                          {company}
                        </Col>
                      </Row>
                      <Row
                        style={{
                          textAlign: "right",
                          height: "50px",
                          paddingTop: "8px",
                          overflow: "hidden",
                        }}
                      >
                        <Col
                          style={{ fontFamily: "YekanBakhVF", height: "50px" }}
                        >
                          {notice.Title}
                        </Col>
                      </Row>
                      <Row style={{ height: "22px" }}>
                        <Col
                          style={{
                            color: ColorPalette.gray[700],
                            fontFamily: "YekanBakhVF",
                          }}
                        >
                          {notice.Category.LocalizedName}
                        </Col>
                      </Row>
                      <Row
                        style={{
                          width: "100%",
                          color: ColorPalette.gray[500],
                          marginTop: "20px",
                        }}
                      >
                        <Col>
                          <Row style={{ height: "18px" }}>
                            <Col style={{ paddingLeft: "5px" }}>
                              <Popover
                                content={<>تست</>}
                                title="بازدید کنندگان"
                                trigger="click"
                                visible={getViewsModal}
                                onVisibleChange={(e) => {
                                  if (
                                    myPositions.positions.companyId ===
                                    "bad6828a-b094-4022-0991-08dbe873e787"
                                  ) {
                                    setModalNoticeId(notice.id);
                                    setViewsModal(true);
                                  }

                                  return;
                                }}
                              >
                                <EyeIconGray />
                              </Popover>
                            </Col>
                            <Col
                              onClick={(e) => {
                                if (
                                  myPositions.positions.companyId ===
                                  "bad6828a-b094-4022-0991-08dbe873e787"
                                ) {
                                  setModalNoticeId(notice.id);
                                  setViewsModal(true);
                                }
                                e.stopPropagation();
                                return;
                              }}
                            >
                              {notice.ViewCount}
                            </Col>
                          </Row>
                          <Row style={{ textAlign: "right" }}>
                            <Col style={{ paddingLeft: "5px" }}>
                              <ClockIcon />
                            </Col>
                            <Col style={{ width: "150px" }}>
                              {notice.DateString}
                            </Col>
                            <Col>
                              <Row style={{ textAlign: "left" }}>
                                <Col className="px-2">
                                  <TedShareIcon />
                                </Col>
                                <Col>
                                  <TedSaveIcon />
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </>
      ) : (
        <> </>
      )}
    </>
  );
};

export default NoticeCardV3;
